import "../../index24.css";
import { jsx as _ } from "react/jsx-runtime";
import { useRef as r } from "react";
import { _ as p } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const a = "_heading_jncp2_1", d = "_center-aligned_jncp2_11", g = "_level-one_jncp2_15", m = "_level-two_jncp2_23", f = "_level-three_jncp2_31", h = "_level-four_jncp2_40", u = "_level-five_jncp2_44", j = "_level-six_jncp2_48", T = "_ellipsized_jncp2_54", e = {
  heading: a,
  centerAligned: d,
  levelOne: g,
  levelTwo: m,
  levelThree: f,
  levelFour: h,
  levelFive: u,
  levelSix: j,
  ellipsized: T
}, x = {
  1: e.levelOne,
  2: e.levelTwo,
  3: e.levelThree,
  4: e.levelFour,
  5: e.levelFive,
  6: e.levelSix
};
function O(i) {
  const {
    className: o,
    level: l = 3,
    children: n,
    ellipsize: c,
    centerAligned: s
  } = i, t = `h${l}`, v = r(null);
  return n ? /* @__PURE__ */ _(
    t,
    {
      className: p(
        e.heading,
        c && e.ellipsized,
        x[l],
        s && e.centerAligned,
        o
      ),
      ref: v,
      children: n
    }
  ) : null;
}
export {
  O as default
};
